export const MAPBOX_LINE_PAINT = {
  'line-color': '#6b99f0',
  'line-width': 4,
};

export const MAPBOX_LINE_LAYOUT = {
  'line-cap': 'round',
  'line-join': 'round',
};
